import MenuButton from 'components/MenuButton';
import { connectContributors } from 'common/services/contributors.service';
import withPermissions from 'connected-components/HOC/PermissionsHOC';
import {
  CAN_EDIT_ACCOUNT_TYPES,
  FEATURE_FLAGS_NAMES
} from '@linearb/linjs-common';
import { useDispatch } from 'react-redux';
import { getContributors, toggleModal } from 'state/callers';
import { mergeMenuButtons } from './ContributorManagementUtils';
import useSettingsService from 'components/hooks/useSettingsService';
import {
  LBMultipleAccountsIcon,
  LBTooltip,
  LBTooltipContent,
  LBTooltipProvider,
  LBTooltipTrigger
} from '@linearb/buzz';

export const ContributorManagementMenuItems = ({
  currentContributor = {},
  teamId = null,
  moreMenuButtons = []
}) => {
  const dispatch = useDispatch();
  const useToast = require('components/hooks/useToast').default;
  const toast = useToast();
  const { getSettingOrDefinitionValue } = useSettingsService();
  const isMergeContributorDisabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isMergeContributorDisabled
  });

  const handleSubmitMerge = async (
    _currentContributorId,
    connectedContributors,
    opName
  ) => {
    dispatch(toggleModal());
    handleMergeAccounts({ connectedContributors, opName, dispatch, toast });
  };
  const onCancel = () => dispatch(toggleModal());

  const menuButtons = mergeMenuButtons({
    currentContributor,
    teamId,
    onCancel,
    handleSubmitMerge,
    dispatch,
    isMergeContributorDisabled
  });

  return withPermissions({
    WrappedComponent: (
      <MenuButton
        width='auto'
        items={[menuButtons, ...moreMenuButtons]}
        clickable={false}
      />
    ),
    requiredPermissions: CAN_EDIT_ACCOUNT_TYPES
  });
};

export function handleMergeAccounts({
  connectedContributors,
  opName,
  dispatch,
  toast
}) {
  try {
    toast({
      message: `${opName} operation started`,
      moreInfo: `NOTE: It might take a few seconds to finish the update`,
      variant: 'success',
      autoHideDuration: 3000
    });

    // we will do an optimistic update and not wait for the backend
    connectContributors(connectedContributors)
      .then(() => {
        toast({
          message: `${opName} operation finished successfully`,
          moreInfo: `NOTE: It might take couple of hours to see updated data reflecting this change.`,
          variant: 'success',
          isOpen: true,
          autoHideDuration: 6000
        });
      })
      .catch(() => {
        toast({
          message: `${opName} operation failed`,
          moreInfo: `Please try again later`,
          variant: 'error',
          isOpen: true,
          autoHideDuration: 6000
        });
      })
      .finally(() => {
        getContributors()(dispatch);
      });
  } catch (e) {
    toast({
      variant: 'error',
      message: 'ERROR',
      moreInfo: 'Operation failed.',
      isOpen: true,
      autoHideDuration: 6000
    });
  }
}

export const MergedUserIcon = ({ childIds }) => {
  return (
    <LBTooltipProvider>
      <LBTooltip>
        <LBTooltipTrigger>
          <LBMultipleAccountsIcon className='size-5 text-slate-400' />
        </LBTooltipTrigger>
        <LBTooltipContent>{childIds.length + 1} Git accounts</LBTooltipContent>
      </LBTooltip>
    </LBTooltipProvider>
  );
};
